import React, { useState } from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
const BRIDGE_URL = 'https://lynjones-monitor-382427532499.us-central1.run.app/webhook/new-contact';
function getGclid(): string {
  try {
    const m = new RegExp('[?&]gclid=([^&]*)').exec(window.location.search);
    if (m && m[1]) {
      const g = decodeURIComponent(m[1].replace(/\+/g, ' '));
      try {
        localStorage.setItem('lj_gclid', g);
      } catch (e) {}
      return g;
    }
    try {
      return localStorage.getItem('lj_gclid') || '';
    } catch (e) {
      return '';
    }
  } catch (e) {
    return '';
  }
}
export function LeadForm({
  title = 'Get Your Free RV Transport Quote',
  source = 'RV PPC Landing'
}: {
  title?: string;
  source?: string;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    fullName: '',
    phone: '',
    email: '',
    pickup: '',
    delivery: '',
    vehicle: '',
    shipDate: ''
  });
  const update = (field: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) => setForm({
    ...form,
    [field]: e.target.value
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    const payload = {
      name: form.fullName,
      email: form.email,
      phone: form.phone,
      source,
      tags: ['request a quote', 'rv ppc'],
      origin_zip: form.pickup,
      destination_zip: form.delivery,
      vehicle: form.vehicle,
      vehicle_type: 'Other',
      transport_type: 1,
      ship_date: form.shipDate,
      gclid: getGclid(),
      do_bats: true,
      do_email: true
    };
    try {
      const res = await fetch(BRIDGE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      setIsSuccess(true);
    } catch (err) {
      setError('Sorry, something went wrong. Please call us at (754) 325-1100 and we will get your quote started right away.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSuccess) {
    return <div className="bg-white p-8 rounded-xl shadow-xl border border-slate-100 flex flex-col items-center justify-center text-center h-full min-h-[400px]" data-id="element-178">
        <CheckCircle2 className="w-16 h-16 text-green-500 mb-4" data-id="element-179" />
        <h3 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-180">
          Quote Request Received!
        </h3>
        <p className="text-slate-600 mb-6" data-id="element-181">
          Thank you. One of our RV transport specialists will contact you
          shortly with your free, no-obligation quote.
        </p>
        <button onClick={() => {
        setIsSuccess(false);
        setForm({
          fullName: '',
          phone: '',
          email: '',
          pickup: '',
          delivery: '',
          vehicle: '',
          shipDate: ''
        });
      }} className="text-brand-navy font-semibold hover:text-brand-red transition-colors" data-id="element-182">
          Submit another request
        </button>
      </div>;
  }
  return <div className="bg-white p-6 md:p-8 rounded-xl shadow-xl border border-slate-100 w-full max-w-lg mx-auto" id="quote-form" data-id="element-183">
      <h3 className="text-2xl font-bold text-brand-navy mb-2 text-center" data-id="element-184">
        {title}
      </h3>
      <p className="text-sm text-slate-500 text-center mb-6 font-medium" data-id="element-185">
        No upfront payment • 100% free quote
      </p>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-186">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-187">
          <div data-id="element-188">
            <label htmlFor="fullName" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-189">
              Full Name
            </label>
            <input required value={form.fullName} onChange={update('fullName')} type="text" id="fullName" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all" placeholder="John Doe" data-id="element-190" />
          </div>
          <div data-id="element-191">
            <label htmlFor="phone" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-192">
              Phone Number
            </label>
            <input required value={form.phone} onChange={update('phone')} type="tel" id="phone" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all" placeholder="(555) 123-4567" data-id="element-193" />
          </div>
        </div>

        <div data-id="element-194">
          <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-195">
            Email Address
          </label>
          <input required value={form.email} onChange={update('email')} type="email" id="email" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all" placeholder="john@example.com" data-id="element-196" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-197">
          <div data-id="element-198">
            <label htmlFor="pickup" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-199">
              Pickup ZIP Code
            </label>
            <input required value={form.pickup} onChange={update('pickup')} type="text" inputMode="numeric" id="pickup" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all" placeholder="e.g. 85001" data-id="element-200" />
          </div>
          <div data-id="element-201">
            <label htmlFor="delivery" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-202">
              Delivery ZIP Code
            </label>
            <input required value={form.delivery} onChange={update('delivery')} type="text" inputMode="numeric" id="delivery" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all" placeholder="e.g. 80014" data-id="element-203" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-204">
          <div data-id="element-205">
            <label htmlFor="vehicle" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-206">
              RV Type & Length
            </label>
            <input required value={form.vehicle} onChange={update('vehicle')} type="text" id="vehicle" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all" placeholder="e.g. 40ft Class A Motorhome" data-id="element-207" />
          </div>
          <div data-id="element-208">
            <label htmlFor="shipDate" className="block text-sm font-semibold text-slate-700 mb-1" data-id="element-209">
              Preferred Ship Date
            </label>
            <input required value={form.shipDate} onChange={update('shipDate')} type="date" id="shipDate" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-navy focus:border-brand-navy outline-none transition-all text-slate-700" data-id="element-210" />
          </div>
        </div>

        {error && <p className="text-sm text-brand-red font-medium text-center" data-id="element-211">{error}</p>}

        <button type="submit" disabled={isSubmitting} className="w-full bg-brand-red hover:bg-brand-red-hover text-white font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center text-lg mt-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-212">
          {isSubmitting ? <>
              <Loader2 className="w-6 h-6 mr-2 animate-spin" data-id="element-213" />
              Processing...
            </> : 'Get My Free Quote'}
        </button>
        <p className="text-xs text-slate-500 text-center mt-3" data-id="element-214">
          By submitting, you agree to our terms. Your information is secure.
        </p>
      </form>
    </div>;
}